#!/usr/bin/env node

//TESTING 123

//used to read in and process command line arguments
const yargs = require("yargs");
//used to color text
const chalk = require("chalk");
//used to put messages in boxes
const boxen = require("boxen");
//reads in .env file and assigns to process.env
const dotenv = require("dotenv");

// 1) Read in settings from .env file if found. The .env file should contain environment variables
// with the following format (one line per variable, '=' no spaces between key & value):
// DB_HOST=localhost
// DB_USER=root
// DB_PASS=s1mpl3
//
// can use the env from process.env.key where key is the name of the environment variable.
dotenv.config();

const epilog = chalk.dim("Darwin Command Line Interface\nCopyright 2019 Darwin Inc. All Rights Reserved.\n")

// 2) Determine what arguments were passed.
const options = yargs
  .commandDir('cmds')
  .demandCommand()
  .help()
  .epilog(epilog)
  .argv

/*
  "@babel/cli": "^7.6.4",
  "@babel/core": "^7.6.4",
  "@babel/node": "^7.6.3",
  "@babel/plugin-proposal-class-properties": "^7.5.5",
  "@babel/preset-env": "^7.6.3",*/
